import Vue from 'vue'

const dateUtil = {
  /**
   * 格式化日期
   * @param {String} fmt 
   * @param {Number} milliseconds 
   * @returns {String}
   */
  format (fmt, milliseconds) {
    const _this = milliseconds ? new Date(milliseconds) : new Date()
    const o = {
      'M+': _this.getMonth() + 1, // 月份
      'd+': _this.getDate(), // 日
      'h+': _this.getHours(), // 小时
      'm+': _this.getMinutes(), // 分
      's+': _this.getSeconds(), // 秒
      'q+': Math.floor((_this.getMonth() + 3) / 3), // 季度
      'S': _this.getMilliseconds() // 毫秒
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (_this.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  },

  /**
   * 月份最后一天
   * @param {Date} dateObject 
   * @returns {Date}
   */
  monthLength (dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      } else {
        dateObject = new Date(dateObject.getTime())
      }
    } catch (error) {
      dateObject = new Date()
    }
    return this.monthLastDay(dateObject).getDate()
  },

  /**
   * 月份最后一天
   * @param {Date} dateObject 
   * @returns {Date}
   */
  monthLastDay (dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      } else {
        dateObject = new Date(dateObject.getTime())
      }
    } catch (error) {
      dateObject = new Date()
    }
    const m = dateObject.getMonth()
    if (m < 11) {
      dateObject.setMonth(m + 1)
    } else {
      dateObject.setFullYear(dateObject.getFullYear() + 1)
      dateObject.setMonth(0)
    }
    dateObject.setDate(1)
    dateObject.setTime(dateObject.getTime() - 24 * 60 * 60 * 1000)
    return dateObject
  },

  /**
   * 月份第一天零点零分零秒
   * @param {Date} dateObject 
   * @returns {Date}
   */
  firstDateMidnight (dateObject = new Date()) {
    dateObject.setDate(1)
    return this.midnight(dateObject)
  },

  /**
   * 补日历后续长度
   * @param {Date} dateObject 
   * @returns {Number}
   */
  supplementDay (dateObject = new Date()) {
    dateObject.setDate(1)
    const a = dateObject.getDay()
    const l = this.monthLength(dateObject)
    const la = 7 - (a + l) % 7
    return la === 7 ? 0 : la
  },

  /**
   * 午夜零点
   * @param {Date} dateObject 
   * @returns {Date}
   */
  midnight (dateObject = new Date()) {
    return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), 0, 0, 0, 0)
  },

  /**
   * 最后一毫秒
   * @param {Date} dateObject 
   * @returns {Date}
   */
  lastMillisecond (dateObject = new Date()) {
    return new Date(dateObject.getFullYear(), dateObject.getMonth(), dateObject.getDate(), 23, 59, 59, 999)
  },

  /**
   * 最近几个月
   * @param {Number} before before默认为0，当before为正时，日期减少相对应的值
   * @param {Date} dateObject dateObject默认为当前时间
   * @returns {Date}
   */
  newlyMonth (before = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() - before * 24 * 3600000)
    const m = dateObject.getMonth()
    if (m === 11) {
      dateObject.setFullYear(dateObject.getFullYear() + 1)
      dateObject.setMonth(0)
    } else {
      dateObject.setMonth(m + 1)
    }
    return dateObject
  },

  /**
   * 加多少年
   * @param {Number} after 加多少天，负数为减
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addYears (after = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setFullYear(dateObject.getFullYear() + after)
    return dateObject
  },

  /**
   * 加多少月
   * @param {Number} after 加多少天，负数为减
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addMonths (after = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    const m = dateObject.getMonth()
    const d = dateObject.getDate()

    dateObject.setDate(1)
    
    while (m + after > 11) {
      dateObject.setFullYear(dateObject.getFullYear() + 1)
      after = after - 12
    }

    while (m + after < -11) {
      dateObject.setFullYear(dateObject.getFullYear() - 1)
      after = after + 12
    }

    dateObject.setMonth(m + after)
    const l = this.monthLastDay(dateObject).getDate()
    dateObject.setDate(l < d ? l : d)
    return dateObject
  },

  /**
   * 加多少天
   * @param {Number} after 加多少天，负数为减
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addDays (after = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() + after * 24 * 3600000)
    return dateObject
  },

  /**
   * 
   * @param {Number} hours 
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addHours (hours = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() + hours * 3600000)
    return dateObject
  },

  /**
   * 
   * @param {Number} minutes 
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addMinutes (minutes = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() + minutes * 60000)
    return dateObject
  },

  /**
   * 
   * @param {Number} seconds 
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addSeconds (seconds = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() + minutes * 1000)
    return dateObject
  },

  /**
   * 
   * @param {Number} milliseconds 
   * @param {Date} dateObject 
   * @returns {Date}
   */
  addMilliseconds (milliseconds = 0, dateObject = new Date()) {
    try {
      if (typeof dateObject !== 'object') {
        dateObject = dateObject ? new Date(dateObject) : new Date()
      }
    } catch (error) {
      dateObject = new Date()
    }
    dateObject.setTime(dateObject.getTime() + milliseconds)
    return dateObject
  }
}

Vue.prototype.$date = dateUtil
